import {
  ExtractFnReturnType,
  InfiniteQueryConfigType,
  useInfiniteQuery,
  UseInfiniteQueryResult,
} from "~/libs";

import { ApiClient } from "~/utils";

import {
  ApisAdminOperatorsCompaniesIndexRequestType,
  ApisAdminOperatorsCompaniesIndexResponseType,
} from "~/domains";

type RequestDataType = {
  params?: ApisAdminOperatorsCompaniesIndexRequestType;
  page?: number;
};

const request = async ({
  params,
  page = 1,
}: RequestDataType): Promise<ApisAdminOperatorsCompaniesIndexResponseType> => {
  const response =
    await new ApiClient().get<ApisAdminOperatorsCompaniesIndexResponseType>(
      "/api/admin_operators/companies",
      { page, ...params },
    );
  return response.data;
};

type QueryFnType = typeof request;

type PropsType = {
  params?: ApisAdminOperatorsCompaniesIndexRequestType;
  config?: InfiniteQueryConfigType<QueryFnType>;
};

export const useApisAdminOperatorsCompaniesIndex = ({
  params,
  config = {},
}: PropsType = {}): UseInfiniteQueryResult<ApisAdminOperatorsCompaniesIndexResponseType> => {
  return useInfiniteQuery<ExtractFnReturnType<QueryFnType>>(
    ["ApisAdminOperatorsCompaniesIndex", params],
    ({ pageParam }) => {
      return request({ params, page: pageParam as number | undefined });
    },
    {
      ...config,
      getNextPageParam: (data) => {
        return data.pagy.hasMore ? data.pagy.currentPage + 1 : false;
      },
    },
  );
};
